export default class Study {
  public id!: string;
  public name !: string;
  public institution !: string;
  public startYear !: number;
  public endYear !: number;
  public studyingHere !: boolean;
  public notFinished !: boolean;
}